import React from 'react';
import {
  Box,
  TextField,
  Card,
  CardContent,
  Button,
  CardHeader,
  Divider,
  Grid,
  InputLabel,
  Container,
  CircularProgress
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import AWS from 'aws-sdk';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// AWS S3 Configuration
AWS.config.update({
  accessKeyId: 'AKIAWX5OXDFHSE3ZUKMI',
  secretAccessKey: '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',
  region: 'ap-south-1'
});

const EditBlog = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [image, setImage] = useState('');
  const [img, setImg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imageErr, setImageErr] = useState(false);

  const s3 = new AWS.S3();

  useEffect(() => {
    fetchBlogData();
  }, [id]);

  const fetchBlogData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/blogs/getblog/${id}`
      );
      const { Title, Content, image } = response.data;
      formik.setValues({ Title, Content, image });
      setImg(image);
    } catch (error) {
      console.error('Error fetching blog data:', error);
    }
  };

  async function handleImageFile(e) {
    setImageErr(false);
    const file = e.target.files[0];
    const folderPath = 'community1/';
    if (file) {
      setImage(file.name);
      const params = {
        Bucket: 'chaturvedi-v2',
        Key: `${folderPath}${Date.now()}_${file.name}`,
        // Key: `${Date.now()}_${file.name}`,
        Body: file,
        ACL: 'public-read', // Ensure this is set according to your permissions
        ContentType: file.type // Set the content type
      };

      try {
        console.log('Uploading to S3...', params);
        const { Location } = await s3.upload(params).promise();
        setImg(Location);
        formik.setFieldValue('image', Location);
        console.log('Upload successful:', Location);
      } catch (error) {
        console.error('Upload failed:', error);
        toast.error(`Upload failed: ${error.message}`, {
          position: 'bottom-right'
        });
      }
    } else {
      setImageErr(true);
    }
  }

  const formik = useFormik({
    initialValues: {
      Title: '',
      Content: '',
      image: ''
    },
    validationSchema: Yup.object({
      Title: Yup.string().required('Title is required'),
      Content: Yup.string().required('Content is required')
    }),
    onSubmit: async (values) => {
      console.log(values, 'check the image url is correct or not');

      try {
        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/blogs/update/${id}`,
          values
        );
        toast.success('Blog updated successfully!', {
          position: 'bottom-right'
        });
        navigate('/blogs');
      } catch (error) {
        toast.error(error.response?.data?.message || 'Update failed', {
          position: 'bottom-right'
        });
      }
    }
  });

  return (
    <Container maxWidth="lg">
      <Card>
        <form onSubmit={formik.handleSubmit} style={{ margin: 30 }}>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Edit Blog"
                titleTypographyProps={{
                  style: {
                    color: '#000',
                    fontWeight: 700,
                    fontSize: '25px',
                    marginBottom: '30px'
                  }
                }}
              />
              {/* <Divider /> */}
              <CardContent>
                <Box component="form" noValidate autoComplete="off">
                  <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {/* Title Field */}
                    <div style={{ margin: 9, width: '45%' }}>
                      <TextField
                        fullWidth
                        label="Title"
                        name="Title"
                        value={formik.values.Title}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.Title && Boolean(formik.errors.Title)
                        }
                        helperText={formik.touched.Title && formik.errors.Title}
                      />
                    </div>
                  </div>

                  {/* Content Field using ReactQuill */}
                  <div style={{ margin: 9, width: '91%' }}>
                    <ReactQuill
                      value={formik.values.Content}
                      onChange={(content) => {
                        formik.setFieldValue('Content', content); // Update Formik state
                      }}
                      onBlur={() => formik.setFieldTouched('Content', true)}
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, false] }],
                          ['bold', 'italic', 'underline'],
                          [{ color: [] }], // color picker added here
                          ['link', 'image'],
                          ['clean']
                        ]
                      }}
                      formats={[
                        'header',
                        'bold',
                        'italic',
                        'underline',
                        'color', // add color format
                        'link',
                        'image'
                      ]}
                    />
                    {formik.touched.Content && formik.errors.Content && (
                      <div style={{ color: 'red', marginTop: '5px' }}>
                        {formik.errors.Content}
                      </div>
                    )}
                  </div>

                  <div style={{ margin: 9, width: '32%' }}>
                    <div style={{ margin: 9 }}>
                      <input type="file" onChange={handleImageFile} />
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {/* <AttachFileIcon />
                    <label>Choose an Image</label> */}
                      </div>
                      {img && (
                        <img
                          src={img}
                          alt="Uploaded"
                          style={{ maxWidth: '170px' }}
                        />
                      )}
                    </div>
                  </div>
                </Box>
              </CardContent>
              {/* Remove this button if it exists */}
              {/* <Button
                color="primary"
                type="submit" // Remove this button
                variant="contained"
              >
                Submit
              </Button> */}
              <div
                style={{
                  display: 'flex',
                  // justifyContent: 'flex-end',
                  margin: '30px'
                }}
              >
                <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button>
              </div>
            </Card>
          </Grid>
        </form>
      </Card>
    </Container>
  );
};

export default EditBlog;
